import { FC } from 'react';

import Select from '@pra-vendas-themes/default/components/Form/Select';
import { IFormFieldSelect } from '@pra-vendas-themes/interfaces/IFormFieldSelect';

import { Collapse } from '../../Collapse';
import { Label, Error } from './styles';

const FormFieldSelect: FC<IFormFieldSelect> = ({
  label,
  width = 1,
  placeholder,
  disabled = false,
  name,
  autoFocus,
  onChange,
  onBlur,
  value,
  error,
  type,
  as,
  maxLength,
  onKeyPress,

  options,
  getOptionLabel,
  getValueLabel,
}) => {
  return (
    <Label htmlFor={name} width={width} disabled={disabled}>
      {label && <span>{label}</span>}
      <Select
        as={as}
        autoFocus={autoFocus}
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        type={type}
        maxLength={maxLength}
        onKeyPress={onKeyPress}
        options={options}
        getOptionLabel={getOptionLabel}
        getValueLabel={getValueLabel}
      />

      <Collapse isOpen={!!error}>
        <Error>{error}</Error>
      </Collapse>
    </Label>
  );
};

export default FormFieldSelect;
